<dx-popup
  [width]="'auto'"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'Please Review and Accept'"
  [hideOnOutsideClick]="false"
  [visible]="popupVisible()"
  [wrapperAttr]="{
    class:
      'modal-window__popup user-agreements-acceptance-popup' +
      (isPWA() ? ' user-agreements-acceptance-popup--pwa' : '')
  }"
  [showCloseButton]="false"
>
  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    cssClass="modal-window__toolbar-item"
    toolbar="bottom"
  >
    <div *dxTemplate>
      <shr-button-with-indicator
        [title]="'SUBMIT'"
        [disabled]="isSubmitDisabled()"
        [cssClass]="'modal-window__toolbar-button'"
        [isInProgress]="inProgressSig()"
        (onClick)="handelSubmitClick()"
      ></shr-button-with-indicator>
    </div>
  </dxi-popup-toolbar-item>

  <div *dxTemplate="let data of 'content'">
    <p class="mb-2">To continue using the Alliance Group Agent Portal, please review and accept our updated <a
      href="#" (click)="openUserAgreementsModal($event, PolicyTypes.termsOfService)" class="ag-link">Terms of Service</a> and <a
      href="#" (click)="openUserAgreementsModal($event, PolicyTypes.privacyPolicy)" class="ag-link">Privacy Policy</a>.</p>

    <div class="d-flex align-items-center">
      <dx-check-box
        [value]="false"
        (onOptionChanged)="userAgreementConfirmationChanged($event)"
      ></dx-check-box>
      <span class="ms-2">I agree to the Terms of Service and Privacy Policy.</span>
    </div>
  </div>
</dx-popup>

